import {
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";

const useStyles = muiStyles;

import { createFormData } from "nhb-toolbox";
import { url } from "src/Helpers/utils/constants";
import { muiStyles } from "src/Utils/Styles";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import { useApiMutation } from "src/hooks/useApiMutation";

interface IProps {
	handleClose: () => void;
	allGuest?: any[];
}
const CreateGuest = ({ handleClose, allGuest }: IProps) => {
	const { register, handleSubmit, reset } = useForm();
	const [guestType, setGuestType] = useState<string>("");
	const [photo, setPhoto] = useState<string>("");
	const { user } = useAuthContext();

	const { mutate: createGuest, isPending } = useApiMutation<FormData, void>({
		method: "POST",
		endPoint: `${url}/api/fair/create/guest-or-speaker?user_admin_id=${user.user_admin_id}`,
		invalidateQueries: ["Guests"],
	});

	const onSubmit = async (inputs: Record<string, any>) => {
		const formData = createFormData({
			...inputs,
			guest_speaker_type: guestType,
			guest_speaker_photo: photo,
		});

		createGuest(formData);
		handleClose();
		reset();
	};

	return (
		<>
			<Helmet>
				<title>BTTF - Create Guest</title>
			</Helmet>

			<Box
				onSubmit={handleSubmit(onSubmit)}
				component="form"
				sx={{ p: 2, mt: 1 }}
			>
				<Grid container spacing={2}>
					<Grid xs={12} sm={6} item>
						<TextField
							margin="normal"
							fullWidth
							required
							id="name"
							label="Guest name"
							{...register("guest_speaker_name")}
							type="text"
							autoFocus
							variant="outlined"
						/>
					</Grid>

					<Grid xs={12} sm={6} item>
						<TextField
							margin="normal"
							fullWidth
							required
							id="name"
							label="Company name"
							{...register("guest_speaker_company_name")}
							type="text"
							autoFocus
							variant="outlined"
						/>
					</Grid>

					<Grid xs={12} sm={6} lg={4} item>
						<TextField
							margin="normal"
							fullWidth
							required
							id="text"
							label="Designation"
							{...register("guest_speaker_designation")}
							type="text"
							autoFocus
							variant="outlined"
						/>
					</Grid>
					<Grid xs={12} sm={6} lg={4} item>
						<FormControl
							variant="outlined"
							fullWidth
							sx={{ mt: 2 }}
						>
							<InputLabel id="demo-simple-select-filled-label">
								Type
							</InputLabel>
							<Select
								labelId="demo-simple-select-filled-label"
								id="demo-simple-select-filled"
								value={guestType}
								onChange={(e) => setGuestType(e.target.value)}
							>
								<MenuItem value="guest">Guest</MenuItem>
								<MenuItem value="speaker">Speaker</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={6} lg={4}>
						<TextField
							margin="normal"
							fullWidth
							id="file"
							label="Choose Guest Photo"
							InputLabelProps={{ shrink: true }}
							onChange={(e: any) => setPhoto(e.target.files)}
							autoComplete="file"
							type="file"
							autoFocus
							required
						/>
					</Grid>
					<Grid item lg={12}>
						<TextField
							label="Guest details"
							placeholder="Enter some details about this Guest here.."
							multiline
							{...register("guest_speaker_details")}
							rows={5}
							maxRows={10}
							fullWidth
						/>
					</Grid>
				</Grid>

				{isPending ? (
					<Button
						disabled
						fullWidth
						variant="contained"
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Creating...
					</Button>
				) : (
					<Button
						type="submit"
						fullWidth
						variant="contained"
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Create Guest
					</Button>
				)}
			</Box>
		</>
	);
};

export default CreateGuest;
